import { Box } from '@chakra-ui/react'
import { riskAssessmentField } from '@hb/shared'
import { FormElement } from '../../../../components/forms'
import { SectionLabel } from '../../SectionLabel'

export const RiskAssessmentInput = () => (
  <Box data-child-name="data.riskAssessment" w="100%" px={5} py="14px">
    <SectionLabel mb={1}>Risk Assessment</SectionLabel>
    <FormElement showName={false} field={riskAssessmentField} name="data.riskAssessment" />
  </Box>
)
